function bindReplaceModal(trigger) {
    const target = document.getElementById(trigger.getAttribute('commandfor'));
    if (!target) {
        return;
    }
    target.addEventListener('command', event => {
        if (event.command === '--replace-modal') {
            const openedModals = Array.from(document.querySelectorAll('dialog[open]'));
            for (const openedModal of openedModals) {
                openedModal.requestClose?.();
            }
            target.showModal?.();
        }
    });
}

window.addEventListener('load', () => {
    const triggers = Array.from(document.querySelectorAll('[command="--replace-modal"]'));
    for (const trigger of triggers) {
        bindReplaceModal(trigger);
    }
});